import { JOB_CREATE_STEPS } from "../config/JOB_CREATE_STEPS";

export function buildJobCreateSteps(ctx) {
  const components = [];
  const config = [];
  const stepperConfig = [];

  JOB_CREATE_STEPS.forEach((step) => {
    if (!step.when(ctx)) return;

    components.push(step.render(ctx));

    const stepConfig = {
      id: config.length,
      name: step.name,
      description: step.description ?? "",
      icon: step.icon,
      validate: step.validate,
      isSubWizard: step.isSubWizard ?? false,
      stepKey: step.key,
      hiddenInStepper: step.hiddenInStepper ?? false,
    };

    config.push(stepConfig);

    if (!step.hiddenInStepper) {
      stepperConfig.push(stepConfig);
    }
  });

  return { components, config, stepperConfig };
}
